<template>
    <v-card class="ma-2 english-level-card">
        <v-card-title class="card-employee-title english-card-title">
            Benefits
            <v-tooltip bottom class="salary-add-button">
                <v-btn :disabled="!isEditEnabled" flat color="black" @click="addNewBenefit()" slot="activator" class="add-phone-btn">
                    <v-icon small color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new benefits</div>
            </v-tooltip>
        </v-card-title>
        <v-card-text class="english-text-card">
            <v-container fluid class="flex-container" v-for="(benefit, index) in employeeBenefits" :key="index">
                <v-layout wrap align-center>
                    <v-flex class="english-level-card" xs12>
                        <v-layout>
                            <v-select content-class="english-level" v-bind:items="benefitsList" class="select-card english-level-select"
                                v-model="benefit.benefit" label="Benefit" single-line bottom :disabled="!isEditEnabled" required
                                item-text="name" item-value="id" return-object @change="changeBenefit($event, index)"
                            ></v-select>
                            <v-tooltip bottom class="facility-icon">
                                <v-btn icon slot="activator" @click.stop="removeBenefit(index)" class="delete-icon" :disabled="!isEditEnabled">
                                    <v-icon color="grey">mdi-delete</v-icon>
                                </v-btn>
                                <span>Delete</span>
                            </v-tooltip>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'EmployeeBenefit',
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                benefits: 'getBenefits'
            }),
            benefitsList: {
                get() {
                    return this.benefits.map(b => ({ name: b.name, id: b.id }));
                }
            },
            employeeBenefits: {
                get() {
                    return this.employee.benefits;
                }
            },
            isEditEnabled() {
                return !this.employee.archived;
            }
        },
        methods: {
            ...mapActions([
                'addEmployeeBenefit',
                'removeEmployeeBenefit',
                'changeEmployeeBenefit'
            ]),
            addNewBenefit() {
                this.addEmployeeBenefit();
            },
            removeBenefit(index) {
                this.removeEmployeeBenefit(index);
            },
            changeBenefit(value, index) {
                this.changeEmployeeBenefit({ name: value.name, id: value.id, index });
            }
        }
    };
</script>

<style scoped>
    .menu__content.menu__content--select.menuable__content__active {
        max-height: 304px !important;
    }
    .english-level-select >>> .input-group__selections__comma {
        margin-top: 6px;
    }
    .flex-container {
        padding: 18px 0 0 0;
    }
    .input-card >>> .input-group__input {
        min-height: 30px !important;
    }
    .item-add-button-icon.btn {
        max-width: 24px;
        max-height: 24px;
    }
    .add-phone-btn >>> .btn__content {
        padding: 0;
    }
    .add-phone-btn {
        min-width: 24px;
        width: 24px;
        min-height: 24px;
        height: 24px;
        margin: 6px 0px 6px 12px;
        background-color: #CED2E6 !important;
    }
    .facility-icon {
        align-self: center;
    }
    .delete-icon.btn.btn--icon .mdi.icon.grey--text.mdi-delete {
        font-size: 20px;
    }
    .delete-icon.btn.btn--icon {
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/reusable/EmployeeBenefit.vue